"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Godfather = void 0;

var _react = _interopRequireWildcard(require("react"));

var _render = _interopRequireDefault(require("./render"));

var _step = _interopRequireDefault(require("./step"));

var _util = require("./util");

var _dequal = require("./dequal");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var getProps = function getProps(events, handleEvent) {
  return Object.fromEntries(events.map(function (event) {
    return [event, handleEvent];
  }));
};

var shouldRender = function shouldRender(props, prevProps) {
  return !(0, _dequal.dequal)(props, prevProps);
};
/**
 * An offer you can't refuse.
 *
 * @param fc the functional component to manage
 * @param props the props to pass to the managed functional component
 * @param events the events we want to monitor
 * @param tocOpts configuration options : { id, stopPropagation, classnames }
 * @returns {JSX.Element}
 */


var Godfather = function Godfather(fc, props) {
  var events = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var tocOpts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    id: 'unnamed ToC',
    stopPropagation: false,
    extraClass: undefined
  };
  var id = tocOpts.id,
      stopPropagation = tocOpts.stopPropagation,
      extraClass = tocOpts.extraClass;
  var gRef = (0, _react.useRef)();
  var prevProps = (0, _util.usePrevious)(props);

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      generatorValue = _useState2[0],
      setGeneratorValue = _useState2[1];

  var onUnmountRef = (0, _react.useRef)(); // Hold the user function to execute on unmount

  var onUnmountReceiver = function onUnmountReceiver(f) {
    onUnmountRef.current = f;
  };

  var handleEvent = function handleEvent(e) {
    var opts = {
      id: id,
      gRef: gRef,
      props: props,
      prevProps: prevProps,
      dbg: {
        event: 'eventHandler'
      },
      onUnmountReceiver: onUnmountReceiver
    }; // noinspection JSIgnoredPromiseFromCall

    (0, _step["default"])(opts, setGeneratorValue);

    if (stopPropagation && e) {
      // TODO Consider allowing selective stop propagation based on an list of events
      e.stopPropagation();
    }
  };
  /**
   * Run user-provided cleanup function on unmount
   */


  (0, _react.useEffect)(function () {
    return function () {
      if (onUnmountRef.current) {
        onUnmountRef.current();
      }
    };
  }, []);
  (0, _react.useEffect)(function () {
    var opts = {
      id: id,
      gRef: gRef,
      props: props,
      prevProps: prevProps,
      dbg: {
        event: 'Props'
      }
    };

    if (!gRef.current) {
      // Happens only on the first run
      var tick = function tick() {
        // noinspection JSIgnoredPromiseFromCall
        (0, _step["default"])(opts, setGeneratorValue);
      };

      var withTick = function withTick(x) {
        return function () {
          return x().then(tick);
        };
      }; // Create the GeneratorFunction object


      var g = (0, _render["default"])(fc(_objectSpread(_objectSpread({}, props), {}, {
        tick: tick,
        withTick: withTick,
        onUnmount: onUnmountReceiver
      })));
      g.id = Math.random(); // Give it an id

      gRef.current = g; // Set the ref

      opts.dbg = {
        event: 'Init'
      };
      /**
       * First call is a dud, exists to initialize `payloadProps` in `render` via `yield`
       * Second call actually runs the functional component using the props
       */

      (0, _step["default"])(opts, setGeneratorValue).then(function () {
        return (0, _step["default"])(opts, setGeneratorValue);
      });
    } else {
      // Rerender on updated props
      if (shouldRender(props, prevProps)) {
        // noinspection JSIgnoredPromiseFromCall
        (0, _step["default"])(opts, setGeneratorValue);
      }
    }
  }, [fc, id, props, prevProps]);

  if (globalThis._react_js_dbg) {
    var _gRef$current;

    return /*#__PURE__*/_react["default"].createElement("div", _extends({}, getProps(events, handleEvent), {
      className: "ticTok-container-".concat(id)
    }), /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        fontSize: '0.8em',
        color: 'yellow',
        backgroundColor: 'black'
      }
    }, id), (0, _util.logState)('ToC Render', {
      id: id,
      instance: (_gRef$current = gRef.current) === null || _gRef$current === void 0 ? void 0 : _gRef$current.id,
      props: props,
      prevProps: prevProps
    }), generatorValue);
  }

  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, getProps(events, handleEvent), {
    className: extraClass ? "react-godfather ".concat(extraClass) : 'react-godfather'
  }), generatorValue);
};

exports.Godfather = Godfather;